import Constant from '@/common/constant/Constant';
import { atom } from 'recoil';


/**
 * Master knowledge hyper link atom
 */
export const masterKnowledgeHyperLinkAtom = atom({
    key: 'masterKnowledgeHyperLinkAtom',
    default: {
        isReload: false,

        type: '',
        visibilitySettingType: '',
        isCustomer: true,
        customerId: '',
        projectSelectedId: '',
        corporationSelectedId: '',
        ticketIdItemList: [],
        // link with master knowledge
        masterKnowledgeHyperLink: true
    }
});




/**
 * Project inuse view structure atom
 */
export const projectInuseViewStructureAtom = atom({
    key: 'projectInuseViewStructureAtom',
    default: Constant.DEFAULT_VIEW_STRUCTURE
});



/**
 * Help desk view structure atom
 */
export const helpdeskViewStructureAtom = atom({
    key: 'helpdeskViewStructureAtom',
    default: {
        ...Constant.DEFAULT_VIEW_STRUCTURE,
        visibility: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
    }
});



/**
 * Project inuse defualt selected option atom
 */
export const projectInuseDefaultSelectedOptionAtom = atom({
    key: 'projectInuseDefaultSelectedOptionAtom',
    default: []
});



/**
 * Help desk default seleced option atom
 */
export const helpdeskDefaultSelectedOptionAtom = atom({
    key: 'helpdeskDefaultSelectedOptionAtom',
    default: []
});



/**
 * Project inuse drill down data
 */
export const projectInuseDrillDownDataAtom = atom({
    key: 'projectInuseDrillDownDataAtom',
    default: []
});



/**
 * Help desk drill down data atom
 */
export const helpdeskDrillDownDataAtom = atom({
    key: 'helpdeskDrillDownDataAtom',
    default: []
});



/**
 * isLoading project inuse drill down data
 */
export const isLoadingProjectInuseDrillDownDataAtom = atom({
    key: 'isLoadingProjectInuseDrillDownDataAtom',
    default: false
});




/**
 * isLoading help desk drill down data
 */
export const isLoadingHelpdeskDrillDownDataAtom = atom({
    key: 'isLoadingHelpdeskDrillDownDataAtom',
    default: false
});




/**
 * Project inuse default drill down data
 */
export const projectInuseDefaultDrillDownDataAtom = atom({
    key: 'projectInuseDefaultDrillDownDataAtom',
    default: []
});



/**
 * Help desk default drill down data
 */
export const helpdeskDefaultDrillDownDataAtom = atom({
    key: 'helpdeskDefaultDrillDownDataAtom',
    default: []
});

export const knowledgeTicketContainAnyAtom = atom({
    key: 'knowledgeTicketContainAnyAtom',
    default: []
});

export const knowledTicketNotIncludeAtom = atom({
    key: 'knowledTicketNotIncludeAtom',
    default: []
});

/**
 * Project inuse view structure atom
 */
export const optionsSortAtom = atom({
    key: 'optionsSortAtom',
    default: Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR
});

export const bulkActionKnowledgeTaskIdAtom = atom({
    key: 'bulkActionKnowledgeTaskIdAtom',
    default: ''
});

export const bulkActionHelpdeskTaskIdAtom = atom({
    key: 'bulkActionHelpdeskTaskIdAtom',
    default: ''
});

export const isDisplayMenuHelpdeskAtom = atom({
    key: 'isDisplayMenuHelpdeskAtom',
    default: false
})

export const destinationPrjIdAtom = atom({
    key: 'destinationPrjIdAtom',
    default: ''
})

export const triggerReLoadKnowledgeTicketDetailAtom = atom({
    key: 'triggerReLoadKnowledgeTicketDetailAtom',
    default: ''
})